import { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { requestGameUrl } from "../../../../store/actionCreators/gameUrl";
import {
  getCurrentRace,
  getGameUrl,
  getToken,
  getUserId,
  getUsername,
} from "../../../../store/selectors";

interface RaceBonusProps {
  onClose: () => void;
}

const RaceBonus: FC<RaceBonusProps> = ({ onClose }) => {
  const dispatch = useDispatch();
  const frameRef = useRef<HTMLIFrameElement | null>(null);
  const gameUrl = useSelector(getGameUrl);
  const token = useSelector(getToken);
  const username = useSelector(getUsername);
  const userId = useSelector(getUserId);
  const currentRace = useSelector(getCurrentRace);

  const handleMountEvent = () => {
    window.addEventListener("message", (event) => {
      if (event.data.type === "MOUNTED") {
        frameRef.current?.contentWindow?.postMessage(
          { type: "LOGIN", user: { token, username, userId } },
          "*"
        );
      }
    });
  };

  useEffect(() => {
    dispatch(requestGameUrl({ id: 1114 }));
    handleMountEvent();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (onClose && window.innerWidth === 0 && window.innerHeight === 0) {
        onClose();
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [onClose]);

  return (
    <div className="my-bonuses__tag__info">
      {gameUrl &&
      ((Array.isArray(currentRace) && currentRace?.length > 0) ||
        Object.keys(currentRace)?.length > 0) ? (
        <iframe
          ref={frameRef}
          className="my-bonuses__raceIframe"
          id="my-bonuses__raceIframe"
          title="raceFrame"
          src={gameUrl.replace("playerToken", "token")}
          allow="autoplay"
        ></iframe>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RaceBonus;
